import { useContext } from 'react'
import HealthClaimFormContext from './context'

export const useHealthClaimForm = () => {
  const context = useContext(HealthClaimFormContext)
  if (!context) {
    throw new Error('useHealthClaimForm must be used within HealthClaimFormProvider')
  }
  return context
}

export default useHealthClaimForm
